export default __webpack_public_path__ + "static/krisan-68870f77d4d9deebb0a0de9e41ca83e8.png";